import router from '../router'

const googleAnalytics = {
  appName: 'Amio Web',
  appVersion: '0.1',
  trackingId: process.env.VUE_APP_GOOGLE_ANALYTICS || 'UA-XXX-X',
  debug: process.env.VUE_APP_LOG_LEVEL === 'debug'
}

const facebookPixel = {
  token: process.env.VUE_APP_FACEBOOK_PIXEL || '',
  debug: process.env.VUE_APP_LOG_LEVEL === 'debug'
}

export default {
  modules: {
    ga: googleAnalytics,
    facebook: facebookPixel
  },
  routing: {
    vueRouter: router
  }
}
